/** @format */

import {useState} from 'react';

import {Trans, useTranslation} from 'react-i18next';

import {useMixpanelContext} from 'contexts/MixpanelContext';

import {FormBody, DescriptionBlock, DescriptionText, InputField, SubmitButton} from '../../styles';

interface Props {
  onSuccess: () => void;
}

const FormState = ({onSuccess}: Props) => {
  const {t} = useTranslation();
  const {mixpanel} = useMixpanelContext();
  const [value, setValue] = useState('');

  const isSubmitDisabled = value.trim().length === 0;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (isSubmitDisabled) return;
    mixpanel.track('submit_analytics_system', {analytics_system_name: value});
    onSuccess();
  };

  return (
    <FormBody component='form' onSubmit={handleSubmit}>
      <DescriptionBlock>
        <DescriptionText>
          <Trans>
            Нам важно знать, какой системой аналитики вы пользуетесь, чтобы быстрее добавить их
            поддержку.
          </Trans>
        </DescriptionText>
        <DescriptionText>
          <Trans>
            Поделитесь с нами названием своей системы аналитики, и это ускорит добавление её в
            AdSensor.
          </Trans>
        </DescriptionText>
      </DescriptionBlock>
      <InputField
        autoFocus
        value={value}
        onChange={e => setValue(e.target.value)}
        placeholder={t('Ввести название', 'Ввести название')}
      />
      <SubmitButton type='submit' disabled={isSubmitDisabled}>
        <Trans>Отправить</Trans>
      </SubmitButton>
    </FormBody>
  );
};

export {FormState};
